<template>
  <div class="containerFull_basketballLeagueCBA">
    <BasketballLeagueCommon
      :containerFullClassName="containerFullClassName"
      :defaultPath="defaultPath"
      :axiosBaseUrl="axiosBaseUrl"
      :sportCompetitionType="sportCompetitionType"
    ></BasketballLeagueCommon>
  </div>
</template>

<script>
// 篮球 联赛 CBA 容器
import BasketballLeagueCommon from './basketballLeague_common.vue'
import containerFull_data from '@mixins/basketball/league/containerFull_cba_data'
export default {
  name: 'containerFull_basketballLeagueCBA',
  mixins: [containerFull_data],
  components: {
    BasketballLeagueCommon,
  },
}
</script>
